import { STYLE_TOKENS } from '../theme';

const BACKGROUND_COLORS = {
  MAIN: STYLE_TOKENS.color.brand.primary,
  SURFACE: STYLE_TOKENS.color.background.surface,
  MUTED: STYLE_TOKENS.color.background.subtle,
};

const TEXT_COLORS = {
  PRIMARY: STYLE_TOKENS.color.text.primary,
  SECONDARY: STYLE_TOKENS.color.text.secondary,
  TERTIARY: STYLE_TOKENS.color.text.tertiary,
  PLACEHOLDER: STYLE_TOKENS.color.text.placeholder,
  DISABLED: STYLE_TOKENS.color.text.disabled,
};

const BORDER_COLORS = {
  SUBTLE: STYLE_TOKENS.color.border.subtle,
  MUTED: STYLE_TOKENS.color.border.muted,
  STRONG: STYLE_TOKENS.color.border.strong,
};

const BRAND_COLORS = {
  PRIMARY: STYLE_TOKENS.color.brand.primary,
  ACCENT: STYLE_TOKENS.color.brand.accent,
  HIGHLIGHT: STYLE_TOKENS.color.brand.highlight,
};

export { BACKGROUND_COLORS, TEXT_COLORS, BORDER_COLORS, BRAND_COLORS };
